import { useLayoutEffect } from "react";
import { getSsoEntryLoginUrl } from "@/config/sso";

/**
 * ADFS `wreply` lands here after sign-out; we then force navigation to
 * `{VITE_SSO_BASE_URL}/{VITE_SSO_APP_ID}` (same as backend `SSO_BASE_URL`/`SSO_APP_ID`).
 */
export default function PostLogoutRedirectPage() {
  useLayoutEffect(() => {
    const url = getSsoEntryLoginUrl().trim();
    if (url) {
      window.location.replace(url);
    } else {
      window.location.replace("/");
    }
  }, []);

  return (
    <div style={{ padding: "1rem", fontFamily: "system-ui, sans-serif" }}>
      Redirecting to sign-in…
    </div>
  );
}
